import React from 'react';

export default function MobileMenu({ links, onSelect, onClose }) {
  return (
    <div className="lg:hidden border-t border-slate-100 bg-white">
      <div className="container-x py-3 grid gap-1">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            onClick={() => onSelect(l.label)}
            className="py-2 text-slate-700 font-medium"
          >
            {l.label}
          </a>
        ))}
        <a href="#admissions" onClick={onClose} className="btn-primary justify-center mt-2">Admission Open</a>
      </div>
    </div>
  );
}
